jQuery(document).ready(function ($) {
	$(window).load(function () {
		setTimeout(function () {
			let hsWrapper = $('.wp_form_footer');

			let hsButton = $('#hs-form-iframe-0').contents().find('.hbspt-form form input[type="submit"]');
			let hsField = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-form-field');
			let hsFieldButton = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-submit .actions');
			let hsInput = $('#hs-form-iframe-0').contents().find('.hbspt-form form input');
			let hsLabel = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hs-form-field > label');
			let hsFirstname = $('#hs-form-iframe-0').contents().find('.hbspt-form form input[name="firstname"]');
			let hsEmail = $('#hs-form-iframe-0').contents().find('.hbspt-form form input[name="email"]');
			let hslink = $('#hs-form-iframe-0').contents().find('.hbspt-form form .hubspot-link__container.sproket');

			hsFirstname.attr('placeholder', 'Nombre');
			hsEmail.attr('placeholder', 'Correo');

			hsField.css('margin', '0');
			hsField.css('margin-bottom', '8px');
			hsFieldButton.css('margin', '0');
			hsFieldButton.css('padding', '0');
			hsInput.css('background-color', '#930134');
			hsInput.css('border-radius', '4px');
			hsInput.css('height', '42px');
			hsInput.css('color', '#F3EDE1');
			hsLabel.css('display', 'none');

			hsButton.css('background-color', '#0E3D31');
			hsButton.css('width', '100%');
			hsButton.css('height', '62px');
			hsButton.css('border', 'none');
			hsButton.css('border-radius', '4px');

			hslink.css('display', 'none');

			hsWrapper.css('display', 'block');
		}, 1000);
	});
});
